import React, { useRef, useEffect } from 'react'

import { useField } from '@unform/core'
import classNames from 'classnames'

import { CnpjInput } from '../../input'
import { Componente, Erro } from './styles'
import { InputUnformProps } from './tipos'

export const CnpjInputUnform: React.FC<Omit<InputUnformProps, 'mascara'>> = ({
  name,
  semMargemAbaixo,
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const {
    fieldName,
    defaultValue,
    registerField,
    error,
    clearError
  } = useField(name || '')

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      getValue({ value }) {
        return value && value.replace(/\D/g, '')
      },
      setValue(ref: any, value: string) {
        ref.setInputValue(value)
      },
      clearValue(ref: any) {
        ref.setInputValue('')
      }
    })
  }, [fieldName, registerField])

  return (
    <Componente
      ComErro={!!error}
      className={classNames({
        semMargemAbaixo
      })}
    >
      <CnpjInput
        {...rest}
        name={name}
        ref={inputRef}
        erro={!!error}
        className={classNames({
          error
        })}
        value={defaultValue}
        onKeyPress={clearError}
      />
      <Erro id={`erro-${rest.id}`}>{error}</Erro>
    </Componente>
  )
}
